/**
 * Format the phone number to return it on a US or BR format
 * @category Formatters
 * @category Phone
 */
export function phoneMask(value?: string, previousValue?: string) {
  if (!value) {
    return value;
  }
  if (value === '+1') {
    return '+1 ';
  }

  const usCode = value.startsWith('+1') ? '+1 ' : '';

  const onlyNums = value.replace('+1 ', '').replace(/[^\d]/g, '');
  if (!previousValue || value.length > previousValue.length) {
    // typing forward
    if (onlyNums.length === 3) {
      return `${usCode}${onlyNums}-`;
    }
    if (onlyNums.length === 6) {
      return `${usCode}${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}-`;
    }
  }
  if (onlyNums.length <= 3) {
    return `${usCode}${onlyNums}`;
  }
  if (onlyNums.length <= 6) {
    return `${usCode}${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
  }
  return `${usCode}${onlyNums.slice(0, 3)}-${onlyNums.slice(
    3,
    6,
  )}-${onlyNums.slice(6, 10)}`;
}
